import React from 'react';

const SvgNz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="NZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="NZ_svg__b" fill="#fff">
        <use xlinkHref="#NZ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#NZ_svg__a" />
      <path fill="#0A17A7" mask="url(#NZ_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M4.333 4.153L-.9-.333H.667l.193.062L5.44 3h1.131l5.762-3.601v.934c0 .296-.17.627-.417.803l-4.25 3.036V5.18l4.3 3.685c.377.323.185.802-.3.802-.257 0-.588-.107-.804-.261L6.56 6.333H5.429L-.333 9.935v-1.44l4.666-3.333V4.153z"
        stroke="#FFF"
        strokeWidth={0.667}
        fill="#FF2E3B"
        mask="url(#NZ_svg__b)"
      />
      <path
        d="M0 3.333V6h4.667v3.34c0 .364.306.66.673.66h1.32a.67.67 0 0 0 .673-.66V6h4.658a.677.677 0 0 0 .676-.673v-1.32a.674.674 0 0 0-.676-.674H7.333V0H4.667v3.333H0z"
        fill="#FFF"
        mask="url(#NZ_svg__b)"
      />
      <path
        fill="#FF2E3B"
        mask="url(#NZ_svg__b)"
        d="M0 4h5.333V0h1.334v4H12v1.333H6.667v4H5.333v-4H0z"
      />
      <path
        fill="#CA1931"
        mask="url(#NZ_svg__b)"
        d="M20 17.333l-.943.276.276-.942-.276-.943L20 16l.943-.276-.276.943.276.942zM20 4.667l-.943.276.276-.943-.276-.943.943.276.943-.276-.276.943.276.943zM24 8.667l-.943.276.276-.943-.276-.943.943.276.943-.276-.276.943.276.943zM16 10l-.943.276.276-.943-.276-.942.943.276.943-.276-.276.942.276.943z"
      />
    </g>
  </svg>
);

export default SvgNz;
